import Head from 'next/head';
import React from 'react';

function Privacy() {
	return (
		<div>
			<Head>
				<title>Privacy Policy</title>
			</Head>
			<div>
				<iframe
					style={{ width: '100%', height: '90vh', border: 'none' }}
					title={'Privacy Policy'}
					src={'https://app.termly.io/document/privacy-policy/2512fd1e-9e4f-4d67-982b-06ada61d6399'}
					allowFullScreen
				/>
			</div>
		</div>
	);
}

export default Privacy;
